import { Station } from '@mi-front/core';
import { useMemo } from 'react';
import { useStationsStore } from '../stores';
import { useYoutubeNativeStations } from './useYoutubeNativeStations';

/**
 * Default YouTube Native station for navigation: most recent among native stations,
 * otherwise first favorite native station, otherwise first native station.
 */
export function useDefaultYoutubeNativeStation(): Station | null {
  const stations = useYoutubeNativeStations();
  const recentStationIds = useStationsStore((state) => state.recentStationIds);
  const favoriteStationIds = useStationsStore((state) => state.favoriteStationIds);

  return useMemo(() => {
    if (stations.length === 0) {
      return null;
    }

    const mostRecentId = recentStationIds.find((id) => stations.some((s) => s.id === id));
    if (mostRecentId) {
      return stations.find((s) => s.id === mostRecentId) ?? stations[0];
    }

    const firstFavoriteId = favoriteStationIds.find((id) => stations.some((s) => s.id === id));
    return stations.find((s) => s.id === firstFavoriteId) ?? stations[0];
  }, [stations, recentStationIds, favoriteStationIds]);
}
